// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 6: Misje Pawła
// ============================================================================
// Poziomy 66-78 (13 poziomów, 39 pytań)

export const chapter6Translations = {
  name: "Misje Pawła",
  description: "Aż po krańce ziemi...",
  
  spiritualWisdom: {
    principle: "Ewangelia jest przeznaczona dla wszystkich narodów i musi być głoszona całemu światu",
    scripture: "Idźcie i czyńcie uczniami wszystkie narody (Mt 28:19)",
    application: "Każdy chrześcijanin jest powołany do dawania świadectwa o Chrystusie tam, gdzie Bóg go umieścił"
  },
  
  levels: {
    66: {
      name: "Pierwsza podróż misyjna",
      challenge: "Wyznaczcie mi Barnabę i Szawła do dzieła, do którego ich powołałem...",
      easy: {
        question: "Kto towarzyszył Pawłowi w jego pierwszej podróży?",
        options: ["Piotr", "Barnaba", "Sylas", "Tymoteusz"],
        hint: "'Syn Pocieszenia'",
        funFact: "👥 Barnaba przyjął Pawła po jego nawróceniu - opatrznościowe partnerstwo!"
      },
      medium: {
        question: "Z jakiego miasta wyruszyli na swoją misję?",
        options: [
          "Jerozolima",
          "Antiochia Syryjska",
          "Tars",
          "Damaszek"
        ],
        hint: "Pierwsza mieszana wspólnota Żydów i pogan",
        funFact: "🚢 Antiochia: port wyjściowy dla ewangelizacji świata zachodniego!"
      },
      hard: {
        question: "Co ujawnia ta pierwsza podróż o strategii misyjnej?",
        options: [
          "Trzeba zostać w swoim regionie",
          "Ewangelia przekracza wszystkie granice kulturowe",
          "Tylko Żydzi mogą być zbawieni",
          "Misja jest opcjonalna"
        ],
        hint: "Chodzi o uniwersalność przesłania",
        funFact: "🌊 Przekroczyć Morze Śródziemne = zrobić krok ku ewangelizacji światowej!"
      }
    },
    
    67: {
      name: "Na Cyprze z Elimasem",
      challenge: "O ty pełen wszelkiego podstępu i wszelkiej przewrotności, synu diabła...",
      easy: {
        question: "Który czarownik sprzeciwił się Pawłowi na Cyprze?",
        options: ["Szymon", "Elimas", "Apollos", "Aleksander"],
        hint: "Fałszywy prorok, który chciał oddalić prokonsula",
        funFact: "🪄 Pierwsze bezpośrednie starcie między Ewangelią a czarami!"
      },
      medium: {
        question: "Co Paweł zrobił Elimasowi jako karę?",
        options: [
          "Wygnał go",
          "Oślepił go tymczasowo",
          "Zignorował go",
          "Debatował z nim"
        ],
        hint: "Tymczasowa ślepota, aby otworzyć mu oczy duchowe",
        funFact: "👁️ Boska ironia: ten, kto zaślepiał dusze, zostaje tymczasowo oślepiony!"
      },
      hard: {
        question: "Jak ten epizod ilustruje moc Ewangelii?",
        options: [
          "Przemoc jest konieczna",
          "Prawda Boża przewyższa fałsz",
          "Trzeba walczyć ze wszystkimi czarodziejami",
          "Paweł był mściwy"
        ],
        hint: "Chodzi o Boży autorytet nad oszustwem",
        funFact: "⚡ Prokonsul uwierzył, widząc moc Bożą - skuteczna demonstracja!"
      }
    },

    68: {
      name: "W Antiochii Pizydyjskiej",
      challenge: "Wam najpierw należało głosić słowo Boże...",
      easy: {
        question: "Gdzie Paweł głosił, gdy przybył do miasta?",
        options: [
          "Na placu publicznym",
          "Najpierw w synagodze",
          "W domach bogatych",
          "W świątyniach pogańskich"
        ],
        hint: "Zawsze zaczynał od swojego ludu",
        funFact: "🕍 Strategia misyjna: najpierw do Żydów, potem do pogan!"
      },
      medium: {
        question: "Jak Żydzi zareagowali na przesłanie Pawła?",
        options: [
          "Wszyscy je przyjęli",
          "Byli podzieleni: jedni uwierzyli, inni się sprzeciwili",
          "Pozostali obojętni",
          "Wygnali go natychmiast"
        ],
        hint: "Klasyczny podział wobec Ewangelii",
        funFact: "⚖️ Ewangelia zawsze dzieli: akceptacja lub odrzucenie, nie obojętność!"
      },
      hard: {
        question: "Dlaczego Paweł zwraca się do pogan?",
        options: [
          "Wolał pogan",
          "Odrzucenie przez Żydów otwiera drzwi narodom",
          "Było to łatwiejsze",
          "Porzucił swoją misję"
        ],
        hint: "Chodzi o wypełnienie proroctwa",
        funFact: "🚪 'Światłość dla narodów' - proroctwo Izajasza spełnione przez Pawła!"
      }
    },

    69: {
      name: "Uzdrowienie w Listrze",
      challenge: "Bogowie w ludzkiej postaci zstąpili do nas!",
      easy: {
        question: "Kogo Paweł uzdrowił w Listrze?",
        options: [
          "Ślepca",
          "Chromego od urodzenia",
          "Głuchoniemego",
          "Trędowatego"
        ],
        hint: "Ktoś, kto nigdy nie chodził",
        funFact: "🦵 Uderzający cud: 'Stań prosto na nogach!' - wiara uzdrawia!"
      },
      medium: {
        question: "Za kogo tłum wziął Pawła i Barnabę?",
        options: [
          "Królów",
          "Bogów (Zeusa i Hermesa)",
          "Czarodziejów",
          "Proroków"
        ],
        hint: "Bóstwa greckiego panteonu",
        funFact: "⚡ Barnaba = Zeus (imponujący), Paweł = Hermes (mówca) - nieporozumienie kulturowe!"
      },
      hard: {
        question: "Jak Paweł zareagował na ten fałszywy kult?",
        options: [
          "Przyjął zaszczyt",
          "Rozdarł szaty i głosił prawdziwego Boga",
          "Milczał z grzeczności",
          "Wykorzystał sytuację"
        ],
        hint: "Całkowite odrzucenie bałwochwalstwa",
        funFact: "👔 Rozdarcie szat = żydowski przerażenie przed bałwochwalstwem - całkowita uczciwość!"
      }
    },

    70: {
      name: "Ukamienowanie i zmartwychwstanie",
      challenge: "Gdy uczniowie otoczyli go, wstał i wszedł do miasta...",
      easy: {
        question: "Co mieszkańcy Listry zrobili Pawłowi?",
        options: [
          "Uwięzili go",
          "Ukamienowali go",
          "Wygnali go",
          "Ukrzyżowali go"
        ],
        hint: "Tradycyjna żydowska kara",
        funFact: "🪨 Od 'boga' do 'martwego' w jeden dzień - ludzka niespójność tłumu!"
      },
      medium: {
        question: "Co Paweł zrobił po ukamienowaniu?",
        options: [
          "Uciekł z miasta",
          "Ukrył się",
          "Wstał i wrócił do miasta",
          "Poszedł do szpitala"
        ],
        hint: "Nadprzyrodzona odwaga po rzekomej śmierci",
        funFact: "💪 Cudowne wskrzeszenie lub Boże uzdrowienie - zdumiewająca odwaga!"
      },
      hard: {
        question: "Co to prześladowanie ujawnia o cenie świadectwa?",
        options: [
          "Trzeba unikać konfliktów",
          "Świadczenie o Chrystusie może kosztować życie",
          "Paweł był nieostrożny",
          "Prześladowanie jest bezużyteczne"
        ],
        hint: "Chodzi o cenę autentycznego świadectwa",
        funFact: "✝️ 'Przez wiele ucisków musimy wejść' - realizm Pawła!"
      }
    },

    71: {
      name: "Sobór Jerozolimski",
      challenge: "Jeśli nie zostaniecie obrzezani, nie możecie być zbawieni...",
      easy: {
        question: "Jaka ważna debata odbyła się na Soborze Jerozolimskim?",
        options: [
          "Chrzest",
          "Obrzezanie nawróconych pogan",
          "Dzień szabatu",
          "Ofiary"
        ],
        hint: "Czy trzeba było stać się Żydem, aby być chrześcijaninem?",
        funFact: "✂️ Wielki pierwszy kryzys: chrześcijaństwo czy judaizm-chrześcijaństwo?"
      },
      medium: {
        question: "Jaka była ostateczna decyzja soboru?",
        options: [
          "Obowiązkowe obrzezanie",
          "Wolność dla pogan z kilkoma zaleceniami",
          "Całkowite oddzielenie od Żydów",
          "Odrzucenie decyzji"
        ],
        hint: "Otwarcie dla pogan bez znaczącego zobowiązania",
        funFact: "🆓 Historyczna rewolucja: Ewangelia uwolniona od prawa Mojżeszowego!"
      },
      hard: {
        question: "Jakie znaczenie ma ten sobór dla Kościoła powszechnego?",
        options: [
          "Drugorzędne wydarzenie",
          "Ustanawia uniwersalność zbawienia przez samą wiarę",
          "Dzieli Kościół",
          "Wzmacnia legalizm"
        ],
        hint: "Chodzi o fundament Kościoła powszechnego",
        funFact: "🌍 Bez tej decyzji chrześcijaństwo pozostałoby sektą żydowską!"
      }
    },

    72: {
      name: "Druga podróż: Tymoteusz",
      challenge: "Paweł chciał go zabrać i obrzezał go ze względu na Żydów...",
      easy: {
        question: "Kto dołączył do Pawła jako młody pomocnik?",
        options: ["Marek", "Łukasz", "Tymoteusz", "Tytus"],
        hint: "'Umiłowany syn' Pawła",
        funFact: "👦 Tymoteusz: młody cudowny chłopiec, który stał się prawą ręką Pawła - udane mentorstwo!"
      },
      medium: {
        question: "Dlaczego Paweł obrzezał Tymoteusza pomimo uzyskanej wolności?",
        options: [
          "Z prawnego obowiązku",
          "Ze strategii misyjnej wśród Żydów",
          "Z tradycji",
          "Z błędu"
        ],
        hint: "Praktyczna mądrość, aby uniknąć przeszkód",
        funFact: "🎯 Wolność z mądrością: 'Być wszystkim dla wszystkich, aby ocalić niektórych'!"
      },
      hard: {
        question: "Jak ta postawa ilustruje elastyczność misyjną?",
        options: [
          "Paweł był niespójny",
          "Dostosował metodę bez kompromisu co do Ewangelii",
          "Uległ presji",
          "Był hipokrytą"
        ],
        hint: "Chodzi o kontekstualną mądrość",
        funFact: "⚖️ Solidne zasady, elastyczne metody - sztuka skutecznego świadectwa!"
      }
    },

    73: {
      name: "Wizja Macedończyka",
      challenge: "Przepraw się do Macedonii i pomóż nam!",
      easy: {
        question: "Co Paweł zobaczył w swoim nocnym widzeniu?",
        options: [
          "Anioła",
          "Macedończyka wzywającego go",
          "Jezusa mówiącego do niego",
          "Wielkie światło"
        ],
        hint: "Wezwanie o pomoc z Europy",
        funFact: "🌉 Decydująca wizja: Ewangelia przekracza do Europy - punkt zwrotny w historii!"
      },
      medium: {
        question: "Jakie było pierwsze europejskie miasto, które zostało ewangelizowane?",
        options: [
          "Ateny",
          "Korynt",
          "Filippi",
          "Tesalonika"
        ],
        hint: "Kolonia rzymska w Macedonii",
        funFact: "🏛️ Filippi: pierwsza wspólnota europejska - kontynent zmieniony na zawsze!"
      },
      hard: {
        question: "Co ta wizja symbolizuje dla historii chrześcijaństwa?",
        options: [
          "Zwykły sen",
          "Opatrznościowa ekspansja na zachód",
          "Halucynacja",
          "Zmiana planów"
        ],
        hint: "Chodzi o Opatrzność kierującą historią",
        funFact: "🗺️ Bez tej wizji Europa mogłaby pozostać pogańska - Boży plan!"
      }
    },

    74: {
      name: "Lidia, pierwsza nawrócona Europejka",
      challenge: "Pan otworzył serce Lidii, aby słuchała...",
      easy: {
        question: "Jaki był zawód Lidii?",
        options: [
          "Piekarka",
          "Handlarka purpurą",
          "Tkaczka",
          "Garncarka"
        ],
        hint: "Luksusowy handel epoki",
        funFact: "🟣 Purpura = królewska barwa bardzo droga - Lidia była dobrze sytuowana!"
      },
      medium: {
        question: "Gdzie Paweł spotkał Lidię?",
        options: [
          "Na rynku",
          "Nad rzeką podczas modlitwy",
          "W jej domu",
          "W synagodze"
        ],
        hint: "Miejsce modlitwy na wolnym powietrzu",
        funFact: "🏞️ Nie było synagogi w Filippi - modlitwa nad wodą według tradycji!"
      },
      hard: {
        question: "Co nawrócenie Lidii ujawnia o działaniu Bożym?",
        options: [
          "Była naturalnie skłonna",
          "Bóg otwiera serca przygotowane na przyjęcie Jego słowa",
          "To był przypadek",
          "Paweł był przekonujący"
        ],
        hint: "Chodzi o Boże działanie w nawróceniu",
        funFact: "💝 'Pan otworzył jej serce' - Bóg przygotowuje i otwiera dusze!"
      }
    },

    75: {
      name: "Więzienie w Filippi",
      challenge: "O północy Paweł i Sylas modlili się i śpiewali hymny Bogu...",
      easy: {
        question: "Dlaczego Paweł i Sylas zostali uwięzieni?",
        options: [
          "Kradzież",
          "Zakłócenie porządku publicznego przez wypędzenie demona",
          "Bluźnierstwo",
          "Bunt"
        ],
        hint: "Uzdrowienie niewolnicy wróżbitki",
        funFact: "💸 Uwolnienie duszy kosztuje drogo jej wykorzystywaczy - prześladowanie ekonomiczne!"
      },
      medium: {
        question: "Co Paweł i Sylas robili w więzieniu?",
        options: [
          "Narzekali",
          "Modlili się i śpiewali",
          "Przygotowywali swoją obronę",
          "Spali"
        ],
        hint: "Chwała pomimo kajdan",
        funFact: "🎵 Hymny o północy w więzieniu - niezachwiana wiara, która robi wrażenie!"
      },
      hard: {
        question: "Jak ich postawa zmieniła sytuację?",
        options: [
          "Nie miała wpływu",
          "Nawróciła strażnika po trzęsieniu ziemi",
          "Rozirytowała strażników",
          "Doprowadziła ich do szaleństwa"
        ],
        hint: "Potężne świadectwo przykładem",
        funFact: "🌍 Trzęsienie ziemi + świadectwo = nawrócenie strażnika i jego rodziny!"
      }
    },

    76: {
      name: "W Atenach: Areopag",
      challenge: "To, co czcicie nie znając, ja wam głoszę...",
      easy: {
        question: "Do jakiego ołtarza Paweł odniósł się w Atenach?",
        options: [
          "Do boga Zeusa",
          "Do Nieznanego Boga",
          "Do Apollina",
          "Do Ateny"
        ],
        hint: "Tajemniczy napis, który posłużył jako punkt wyjścia",
        funFact: "🏛️ 'Nieznanemu Bogu' - genialny punkt kontaktu z grecką filozofią!"
      },
      medium: {
        question: "Przed kim Paweł głosił w Atenach?",
        options: [
          "Zwykłym tłumem",
          "Filozofami epikurejskimi i stoickimi na Areopagu",
          "Kapłanami świątyń",
          "Cesarzem rzymskim"
        ],
        hint: "Grecka elita intelektualna",
        funFact: "🧠 Areopag = starożytny Harvard - Paweł przed największymi myślicielami!"
      },
      hard: {
        question: "Jaka była reakcja Ateńczyków na zmartwychwstanie?",
        options: [
          "Jednomyślna akceptacja",
          "Podział: szyderstwo niektórych, zainteresowanie innych",
          "Powszechny gniew",
          "Całkowita obojętność"
        ],
        hint: "Typowa reakcja intelektualistów na tę tajemnicę",
        funFact: "🤔 Zmartwychwstanie = kamień obrazy dla dumnej ludzkiej inteligencji!"
      }
    },

    77: {
      name: "Korynt: Paweł wytwórca namiotów",
      challenge: "Pozostał z nimi i pracował, gdyż z zawodu byli wytwórcami namiotów...",
      easy: {
        question: "W jakim zawodzie Paweł pracował, aby się utrzymać?",
        options: [
          "Rybak",
          "Wytwórca namiotów",
          "Skryba",
          "Kupiec"
        ],
        hint: "Rzemiosło, którego się nauczył",
        funFact: "⛺ Paweł: apostoł-rzemieślnik - szacunek dla pracy ręcznej wśród chrześcijan!"
      },
      medium: {
        question: "U kogo Paweł gościł w Koryncie?",
        options: [
          "W gospodzie",
          "U Akwili i Pryscylli",
          "U gubernatora",
          "W synagodze"
        ],
        hint: "Para wytwórców namiotów jak on",
        funFact: "👫 Akwila i Pryscylla: wzorowa para misyjna - chrześcijańska gościnność!"
      },
      hard: {
        question: "Dlaczego Paweł pracował własnymi rękami?",
        options: [
          "Tylko z konieczności ekonomicznej",
          "Aby nie być ciężarem i uwiarygodnić swoje świadectwo",
          "Z tradycji rodzinnej",
          "Ponieważ lubił ten zawód"
        ],
        hint: "Chodzi o niezależność i wiarygodność",
        funFact: "💼 Niezależność ekonomiczna = wolność słowa - Paweł nie był od nikogo zależny!"
      }
    },

    78: {
      name: "Zamieszki w Efezie",
      challenge: "Wielka jest Artemida Efeska!",
      easy: {
        question: "Kto wywołał zamieszki przeciwko Pawłowi w Efezie?",
        options: [
          "Władze rzymskie",
          "Demetriusz złotnik i rzemieślnicy",
          "Filozofowie",
          "Żydowscy kapłani"
        ],
        hint: "Ci, którzy wytwarzali świątynie Artemidy",
        funFact: "🏛️ Pierwszy strajk w historii: Ewangelia zagraża ekonomii bałwochwalczej!"
      },
      medium: {
        question: "Jak długo Paweł nauczał w Efezie?",
        options: [
          "6 miesięcy",
          "1 rok",
          "2 lata",
          "3 lata"
        ],
        hint: "Jego najdłuższy pobyt misyjny",
        funFact: "📅 3 lata intensywnego nauczania - Efez stał się ważnym centrum misyjnym!"
      },
      hard: {
        question: "Co te zamieszki ujawniają o społecznym wpływie Ewangelii?",
        options: [
          "Ewangelia nic nie zmienia",
          "Przekształca struktury ekonomiczne i społeczne",
          "Dotyczy tylko religii",
          "Unika konfliktów"
        ],
        hint: "Chodzi o głęboką zmianę społeczną",
        funFact: "💰 Gdy Ewangelia postępuje, bałwany tracą swój rynek - wpływ ekonomiczny!"
      }
    }
  }
};

export default chapter6Translations;
